"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ignite = ignite;
const nanostores_1 = require("nanostores");
const fonts_1 = require("../shared/fonts");
const CanvasManager_1 = __importDefault(require("./CanvasManager"));
const controls = __importStar(require("./controls"));
const data_1 = require("./data");
const fonts_2 = require("./fonts");
const paints_1 = require("./paints");
const PhantomTextArea_1 = __importDefault(require("./PhantomTextArea"));
const renderers_1 = require("./renderers");
const TextModel_1 = __importDefault(require("./TextModel"));
const clamp_1 = __importDefault(require("lodash/clamp"));
async function ignite(kit) {
    const canvasManager = new CanvasManager_1.default(kit, "canvas");
    const fontMgr = await (0, fonts_2.loadFonts)(kit);
    const paragraphStyleStore = (0, nanostores_1.computed)(controls.fontSize, (fontSize) => new kit.ParagraphStyle({
        textStyle: {
            color: kit.BLACK,
            fontFamilies: fonts_1.fontFamilies,
            fontSize,
        },
        textAlign: kit.TextAlign.Left,
    }));
    const modelStore = (0, nanostores_1.atom)(new TextModel_1.default(data_1.sampleText));
    const selectionStore = (0, nanostores_1.atom)([2, 100]);
    modelStore.subscribe((model) => {
        const selection = selectionStore.get();
        if (selection === null || selection === undefined) {
            selectionStore.set(null);
        }
        else if (typeof selection === "number") {
            selectionStore.set(model.clampPosition(selection));
        }
        else {
            selectionStore.set(model.clampRange(selection));
        }
    });
    const paragraphStore = (0, nanostores_1.computed)([modelStore, controls.width, paragraphStyleStore], (model, width, paragraphStyle) => {
        const builder = kit.ParagraphBuilder.Make(paragraphStyle, fontMgr);
        builder.addText(model.text);
        const paragraph = builder.build();
        paragraph.layout(width);
        return paragraph;
    });
    const shapedLinesStore = (0, nanostores_1.computed)(paragraphStore, (paragraph) => paragraph.getShapedLines());
    const scrollBaseY = (0, nanostores_1.atom)(0);
    const mouseOffsetY = (0, nanostores_1.computed)(scrollBaseY, (x) => -x);
    // Event actions
    const performMoveLeft = performMoveBetweenColumns.bind(null, -1);
    const performMoveRight = performMoveBetweenColumns.bind(null, 1);
    const performMoveUp = performMoveBetweenRows.bind(null, true);
    const performMoveDown = performMoveBetweenRows.bind(null, false);
    let isMouseDown = false;
    let lastMousePosition = null;
    const mousePositionStore = (0, nanostores_1.atom)(null);
    canvasManager.addEventListener("mouseenter", (e) => {
        lastMousePosition = [e.offsetX, mouseOffsetY.get() + e.offsetY];
        mousePositionStore.set([e.offsetX, mouseOffsetY.get() + e.offsetY]);
    });
    canvasManager.addEventListener("mouseleave", () => {
        lastMousePosition = null;
        mousePositionStore.set(null);
        isMouseDown = false;
    });
    canvasManager.addEventListener("mousemove", (e) => {
        lastMousePosition = [e.offsetX, mouseOffsetY.get() + e.offsetY];
        mousePositionStore.set([e.offsetX, mouseOffsetY.get() + e.offsetY]);
        if (isMouseDown) {
            extendSelection(...lastMousePosition);
        }
    });
    canvasManager.addEventListener("mousedown", (e) => {
        lastMousePosition = [e.offsetX, mouseOffsetY.get() + e.offsetY];
        mousePositionStore.set([e.offsetX, mouseOffsetY.get() + e.offsetY]);
        isMouseDown = true;
        resetSelection(...lastMousePosition);
    });
    canvasManager.addEventListener("dblclick", (e) => {
        const model = modelStore.value;
        if (model && paragraphStore.value) {
            lastMousePosition = [e.offsetX, mouseOffsetY.get() + e.offsetY];
            mousePositionStore.set([e.offsetX, mouseOffsetY.get() + e.offsetY]);
            const { pos } = paragraphStore.value.getGlyphPositionAtCoordinate(...lastMousePosition);
            selectionStore.set(model.getWordIncludingPosition(pos));
        }
    });
    canvasManager.addEventListener("mouseup", (e) => {
        lastMousePosition = [e.offsetX, mouseOffsetY.get() + e.offsetY];
        isMouseDown = false;
    });
    canvasManager.addEventListener("wheel", (e) => {
        e.preventDefault();
        const paragraph = paragraphStore.get();
        const paragraphHeight = paragraph.getHeight();
        const canvasHeight = canvasManager.height;
        scrollBaseY.set((0, clamp_1.default)(scrollBaseY.get() + e.deltaY, Math.min(canvasHeight - paragraphHeight, 0), 0));
    });
    canvasManager.addEventListener("keydown", (e) => {
        switch (e.key) {
            case "Backspace":
                performBackspace();
                break;
            case "Delete":
                performDelete();
                break;
            case "ArrowUp":
                performMoveUp();
                break;
            case "ArrowDown":
                performMoveDown();
                break;
            case "ArrowLeft":
                performMoveLeft();
                break;
            case "ArrowRight":
                performMoveRight();
                break;
        }
    });
    const selectionRegionsStore = (0, nanostores_1.computed)([modelStore, selectionStore, paragraphStore], (model, selection, paragraph) => {
        if (selection === null) {
            return null;
        }
        else if (typeof selection === "number") {
            let low;
            let high;
            let useX1 = false;
            // Special case: caret in the beginning.
            if (selection === 0) {
                [low, high] = [0, 1];
            }
            // Special case: caret in the end.
            else if (selection === model.text.length) {
                [low, high] = [selection - 1, selection];
                useX1 = true;
            }
            // Normal case.
            else {
                [low, high] = [selection, selection + 1];
            }
            const rects = paragraph.getRectsForRange(low, high, kit.RectHeightStyle.Max, kit.RectWidthStyle.Tight);
            // It should be greater than 0.
            if (rects.length > 0) {
                const [[x0, y0, x1, y1]] = rects;
                return { regions: null, caret: [useX1 ? x1 : x0, y0, y1] };
            }
            else {
                console.warn("getRectsForRange should return at least one rectangle");
                return null;
            }
        }
        else {
            let [low, high] = selection;
            const useLast = low > high;
            if (low > high) {
                [high, low] = selection;
            }
            const rects = paragraph.getRectsForRange(low, high, kit.RectHeightStyle.Max, kit.RectWidthStyle.Tight);
            if (rects.length > 0) {
                const rect = useLast ? rects[rects.length - 1] : rects[0];
                const [x0, y0, x1, y1] = rect;
                return {
                    regions: rects,
                    caret: [useLast ? x1 : x0, y0, y1],
                };
            }
            else {
                return null;
            }
        }
    });
    selectionRegionsStore.listen((value) => {
        if (value === null) {
            textArea.hide();
        }
        else {
            const [x, y0, y1] = value.caret;
            textArea.height = Math.abs(y1 - y0);
            textArea.move(x, y0);
            textArea.show();
            textArea.focus();
        }
    });
    const textArea = new PhantomTextArea_1.default();
    textArea.addEventListener("insert", (event) => {
        const model = modelStore.value;
        const selection = selectionStore.value;
        if (model === undefined || selection === null || selection === undefined) {
            return;
        }
        else if (typeof selection === "number") {
            const [newModel, position] = model.insert(selection, event.text);
            modelStore.set(newModel);
            selectionStore.set(position);
        }
        else {
            let [newModel, position] = model.strip(...selection);
            [newModel, position] = newModel.insert(position, event.text);
            modelStore.set(newModel);
            selectionStore.set(position);
        }
    });
    textArea.addEventListener("backspace", performBackspace);
    textArea.addEventListener("delete", performDelete);
    textArea.addEventListener("left", performMoveLeft);
    textArea.addEventListener("right", performMoveRight);
    textArea.addEventListener("up", performMoveUp);
    textArea.addEventListener("down", performMoveDown);
    function resetSelection(x, y) {
        if (paragraphStore.value) {
            selectionStore.set(paragraphStore.value.getGlyphPositionAtCoordinate(x, y).pos);
        }
    }
    function extendSelection(x, y) {
        if (paragraphStore.value) {
            const { pos } = paragraphStore.value.getGlyphPositionAtCoordinate(x, y);
            const selection = selectionStore.value;
            if (selection === null || selection === undefined) {
                selectionStore.set(pos);
            }
            else if (typeof selection === "number") {
                selectionStore.set([selection, pos]);
            }
            else {
                selectionStore.set([selection[0], pos]);
            }
        }
    }
    function performBackspace() {
        const model = modelStore.value;
        const selection = selectionStore.value;
        if (model === undefined || selection === null || selection === undefined) {
            return;
        }
        else if (typeof selection === "number") {
            const [newModel, position] = model.deleteBackward(selection);
            modelStore.set(newModel);
            selectionStore.set(position);
        }
        else {
            const [newModel, position] = model.strip(...selection);
            modelStore.set(newModel);
            selectionStore.set(position);
        }
    }
    function performDelete() {
        const model = modelStore.value;
        const selection = selectionStore.value;
        if (model === undefined || selection === null || selection === undefined) {
            return;
        }
        else if (typeof selection === "number") {
            const [newModel, position] = model.deleteForward(selection);
            modelStore.set(newModel);
            selectionStore.set(position);
        }
        else {
            const [newModel, position] = model.strip(...selection);
            modelStore.set(newModel);
            selectionStore.set(position);
        }
    }
    function performMoveBetweenColumns(delta) {
        const model = modelStore.value;
        const selection = selectionStore.value;
        if (model === undefined || selection === null || selection === undefined) {
            return;
        }
        else if (typeof selection === "number") {
            selectionStore.set(model.clampPosition(selection + delta));
        }
        else {
            selectionStore.set(model.clampPosition(Math.min(...selection) + delta));
        }
    }
    function performMoveBetweenRows(upward) {
        const selectionRegions = selectionRegionsStore.value;
        const fontSize = controls.fontSize.get();
        if (selectionRegions === null ||
            selectionRegions === undefined ||
            paragraphStore.value === undefined) {
            return;
        }
        const [x, y0, y1] = selectionRegions.caret;
        const y = (upward ? Math.min : Math.max)(y0, y1);
        const glyphPosition = paragraphStore.value.getGlyphPositionAtCoordinate(x, upward
            ? Math.max(0, y - fontSize / 2)
            : Math.min(canvasManager.height, y + fontSize / 2));
        // Update the selection.
        selectionStore.set(glyphPosition.pos);
    }
    const paints = (0, paints_1.getDefaultPaints)(kit);
    const debugLayerDataStore = (0, nanostores_1.computed)([
        controls.showCursorPosition,
        controls.showGlyphBorders,
        shapedLinesStore,
        mousePositionStore,
    ], (showCursorPosition, showGlyphBorders, shapedLines, mousePosition) => ({
        shapedLines: showGlyphBorders ? shapedLines : null,
        lastMousePosition: showCursorPosition ? mousePosition : null,
    }));
    const frameDataStore = (0, nanostores_1.computed)([selectionRegionsStore, paragraphStore, scrollBaseY, debugLayerDataStore], (selectionRegions, paragraph, offsetY, debugLayerData) => paragraph === null
        ? null
        : { selectionRegions, paragraph, offsetY, ...debugLayerData });
    frameDataStore.subscribe((data) => {
        if (data !== null) {
            canvasManager.requestAnimationFrame((canvas) => {
                (0, renderers_1.renderFrame)(canvasManager, canvas, data, paints);
                (0, renderers_1.renderDebugLayer)(canvasManager, canvas, data, paints);
            });
        }
    });
}
